import * as CompanyWardTypes from "../types/companyward.types";

import * as UiTypes from "../types/ui.types";
import axiosInstance from "../../api";
import { alertActions } from "./alert.actions";

export const loadCompanies = (filter: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: CompanyWardTypes.LOADING_COMPANYWARD });
  axiosInstance
    .get("/subfacility/", { params: { ...filter } })
    .then((res) => {
      dispatch({
        type: CompanyWardTypes.LOAD_COMPANYWARD,
        payload: res.data,
      });
      dispatch({ type: UiTypes.CLEAR_ERRORS });
    })
    .catch((err) => {
      if (err.message) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.message,
        });
        dispatch(alertActions.error(err.message));
      } else if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const trashCompany = (id: any, filterData: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .delete("/subfacility/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch(alertActions.success("Delete Success"));

      dispatch(loadCompanies(filterData));
      dispatch(loadCompanyList());
    })
    .catch((err) => {
      dispatch(alertActions.showError(err, "Error deleting data"));
    });
};

export const blukTrashCompany =
  (id: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    axiosInstance
      .delete("/subfacility/", id)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(alertActions.success("Delete Success"));

        dispatch(loadCompanies(filterData));
        dispatch(loadCompanyList());
      })
      .catch((err) => {
        dispatch(alertActions.showError(err, "Error deleting data"));
      });
  };

export const saveCompany =
  (userData: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: CompanyWardTypes.COMPANYWARD_SAVE_REQUEST });

    axiosInstance
      .post("subfacility/", userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(alertActions.success("Facilty Created Successfully"));
        dispatch({ type: CompanyWardTypes.COMPANYWARD_SAVE_SUCCESS });
        dispatch(loadCompanies(filterData));
        dispatch(loadCompanyList());
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };

export const getCompany = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: CompanyWardTypes.FETCH_COMPANYWARD_REQUEST });

  axiosInstance
    .get("subfacility/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: CompanyWardTypes.FETCH_COMPANYWARD_REQUEST_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};

export const updateCompany =
  (userData: any, id: number, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: CompanyWardTypes.COMPANYWARD_SAVE_REQUEST });

    axiosInstance
      .put("subfacility/" + id, userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch({ type: CompanyWardTypes.COMPANYWARD_SAVE_SUCCESS });
        dispatch(alertActions.success("Facilty Updated Successfully"));
        dispatch(loadCompanies(filterData));
        dispatch(loadCompanyList());
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };

export const searchCompanies = (filter: string) => {
  let result = axiosInstance
    .get("/subfacility/?q=" + filter)
    .then((res) => {
      return res.data.results;
    })
    .catch((err) => {
      return err;
    });
  return result;
};

export const updateCompanyStatus =
  (userData: any, id: number, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: CompanyWardTypes.COMPANYWARD_SAVE_REQUEST });

    axiosInstance
      .put("subfacility/status/" + id, userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch({ type: CompanyWardTypes.COMPANYWARD_SAVE_SUCCESS });
        dispatch(alertActions.success("Facilty Updated Successfully"));
        dispatch(loadCompanies(filterData));
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };

export const loadCompanyList = () => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  //dispatch({ type: CompanyWardTypes.FETCH_COMPANYWARD_COMPANY_LIST_REQUEST_SUCCESS });

  axiosInstance
    .get("subfacility/facilitylist/")
    .then((res) => {
      dispatch({
        type: CompanyWardTypes.FETCH_COMPANYWARD_COMPANY_LIST_REQUEST_SUCCESS,
        payload: res.data,
      });
      dispatch({ type: UiTypes.CLEAR_ERRORS });
    })
    .catch((err) => {
      if (err.message) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.message,
        });
        dispatch(alertActions.error(err.message));
      } else if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};
